import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { EStatusFindClient, EDocumentTypeId, IEventResponseFindClient } from '../form-solicitation-basic-data/form-solicitation-basic-data.component';
import { ISolicitation } from './../../shared/models/solicitation-models/solicitation/SolicitationModel';
import { CatalogService, EPersonType } from './../../shared/services/catalogs/catalog.service';
import { CopyService } from './../../shared/services/copies/copy.service';
import { RequestSolicitationsService } from '../../shared/services/solicitations/request-solicitations.service';
import { getValueProperty as getValue, getValueProperty, setValueProperty } from '../../shared/helpers/functions.helpers';
import { TokenService } from './../../shared/services/security/token.service';
import { IVclAutocompleteEvent, VclOptionComponent } from '@voxel/community';
import { ApplicationService } from '../../shared/services/application/application.service';
import { BaseComponent } from '../../shared/components/base-component';
import { LinkupService } from '../../shared/services/link-up/linkup.service';

@Component({
    selector: 'app-solicitation-start',
    templateUrl: './solicitation-start.component.html',
    styleUrls: ['./solicitation-start.component.scss']
})
export class SolicitationStartComponent extends BaseComponent implements OnInit {

    /**
     * Almacena los datos recolectados en el formulario principal
     */
    form: FormGroup = this.fb.group({
        basic_data: this.fb.group({}),
        contacts_data: this.fb.group({}),
    });

    /**
     * Contiene los textos y etiquetas
     */
    CONTENT_BOUNDS: any[] | any;

    /**
     * Almacena los pasos del formulario
     */
    stepsList: string[] = [];

    /**
     * Almacena los datos digitados por el cliente en pasos anteriores
     */
    solicitationData: ISolicitation = {};

    ev: EventEmitter<IVclAutocompleteEvent> | any = new EventEmitter<IVclAutocompleteEvent>(true);

    showContactForm = false;

    /**
     * Constructor de la clase SolicitationStartComponent
     * @param _solicitation Servicio para la manipulacion del estado de la solicitud
     * @param cps Servicio para la carga de textos estaticos
     * @param fb Clase encargada de cla creación y manipulación de formularios
     */
    constructor(
        private readonly _solicitation: RequestSolicitationsService,
        private readonly cps: CopyService,
        private readonly fb: FormBuilder,
        private readonly _token: TokenService,
        private readonly app: ApplicationService,
        private readonly link: LinkupService,
        private readonly _catalog: CatalogService
    ) {
        super(app, link, "solicitation-start")
    }

    /**
     * Inicializamos variables y objetos de la clase
     */
    ngOnInit(): void {
        this._solicitation.navigation.startFlow();
        this.loadStaticValues();
        this.loadData();
        this.basicDataForm.addControl('filter', new FormControl('', Validators.nullValidator));
        this.app.currentApplication = "digitalSolicitations";
        // this.ev.subscribe(this.select());
    }

    /**
     * Permite la carga de textos y listas estaticas
     */
    async loadStaticValues() {
        await super.loadStaticValues();
        this._catalog.clearCache();
        this.CONTENT_BOUNDS = await this.cps.getCopy("solicitation-start");
        this.stepsList = await this.cps.getCopy("stepList", []);
    }

    /**
     * Permite cargar la información proveniente de los pasos anteriores
     */
    loadData() {
        this.solicitationData = this._solicitation.solicitation;
        this.showContactForm = getValueProperty(this.solicitationData, 'basicData.customer_loaded', false);
        if (!this.solicitationData) {
            this._token.loadTransactionId();
        }
    }

    /**
     * Encargado de controlar la navegación en el componente
     * @param start
     */
    async navigateTo(start: any) {
        if (start === "next") {
            this.solicitationData.basicData = this.basicDataForm.value;
            this.solicitationData.contactsData = this.contactsDataForm.value;
            const isNaturalPerson = this.solicitationData.basicData?.isNaturalPerson;

            if(isNaturalPerson){
                setValueProperty(this.solicitationData, 'contactsData.contact_primary.names', this.solicitationData.basicData?.client_names);
                setValueProperty(this.solicitationData, 'contactsData.contact_primary.surnames', this.solicitationData.basicData?.client_surnames);
            }
            
            this._solicitation.solicitation = this.solicitationData;
            console.log("navigateTo", this.solicitationData);
            
            await this._solicitation.navigation.nextStep();
        } else {
            await this._solicitation.navigation.previousStep();
        }
    }

    /**
     *  Controla el evento de salida principal
     * @param $event
     */
    onCloseEvent($event: any) {
        console.log('close event', $event);
    }

    /**
     * Permite obtener la instancia del formulario para la información basica del cliente
     */
    get basicDataForm(): FormGroup {
        return this.form.get('basic_data') as FormGroup;
    }

    /**
     * Permite consultar el cliente en phoenix y precargar los datos en memoria
     * @param $event
     */
    async findClient($event: IEventResponseFindClient) {
        if ($event.status === EStatusFindClient.FOUND && getValue($event, 'client')) {
            const client = getValue($event, 'client');
            let phone1 = '';
            let phone2 = '';
            if (getValue(client, 'phones')) {

                let countPhone = 0;
                for (const phone of getValue(client, 'phones', [])) {
                    if (countPhone === 2) {
                        break;
                    } else if (countPhone === 0) {
                        phone1 = getValue(phone, 'phone_number');
                    } else if (countPhone === 1) {
                        phone2 = getValue(phone, 'phone_number');
                    }
                    countPhone++;
                }
            }

            let names = getValue(client, 'given_names', []).join(' ');
            let surnames = getValue(client, 'family_names', []).join(' ');
            let namesContact = '';
            let surnamesContact = '';
            const NAME_LENGTH = await this.nameLengthContacts();

            if ($event.documentType === EDocumentTypeId.NIT) {
                
                namesContact = `${names} ${surnames}`.trim().substring(0, NAME_LENGTH);
                surnamesContact = `${names} ${surnames}`.trim().substring(0, NAME_LENGTH);
            } else {
                namesContact = names.trim().substring(0, NAME_LENGTH);
                surnamesContact = surnames.trim().substring(0, NAME_LENGTH);
            }

            this.solicitationData.contactsData = {
                CA_Names: getValue(getValue(client, 'manager'), 'name', ''),
                CA_LastName: '',
                CA_Phone: '',
                CA_Email: '',
                CA_CodeProduct: getValue(client, 'originator_branch', ''),
                SA_Names: this.getUserData(),
                SA_LastName: '',
                SA_Phone: '',
                SA_Email: '',
                contact_primary: {
                    names: namesContact,
                    surnames: surnamesContact,
                    phone_1: phone1,
                    email: getValue(client, 'email'),
                    contact_exist: true
                },
                contact_additional: {
                    names: '',
                    surnames: '',
                    phone_1: '',
                    email: '',
                    contact_exist: false
                }
            };
            this.contactsDataForm.patchValue(this.solicitationData.contactsData);
            this.solicitationData.additionalData = {
                SolicitationType: '',
                SolicitationSubtype: '',
                Annotations: '',
                Cell: { id: '', name: '' },
                CustomerTypes: ($event.documentType === EDocumentTypeId.NIT || $event.documentType === EDocumentTypeId.SE) ? EPersonType.PERSON_TYPE_JUR : EPersonType.PERSON_TYPE_NAT
            };

            // En caso de error en phoenix
        } else if ($event.status === EStatusFindClient.ERROR) {
            this.solicitationData.contactsData = undefined;
            this.basicDataForm.patchValue({
                customer_exists: false,
                customer_loaded: true,
                customer_error: true
            });
            this.solicitationData.additionalData = {
                SolicitationType: '',
                SolicitationSubtype: '',
                Annotations: '',
                Cell: { id: '', name: '' },
                CustomerTypes: ($event.documentType === EDocumentTypeId.NIT || $event.documentType === EDocumentTypeId.SE) ? EPersonType.PERSON_TYPE_JUR : EPersonType.PERSON_TYPE_NAT
            };
        } else if ($event.status === EStatusFindClient.FOUND_CLIENT_VALIDATION) {
            this.solicitationData.contactsData = undefined;
            this.basicDataForm.patchValue({
                customer_exists: true,
                customer_loaded: true,
                customer_error: false
            });
            this.solicitationData.additionalData = {
                SolicitationType: '',
                SolicitationSubtype: '',
                Annotations: '',
                Cell: { id: '', name: '' },
                CustomerTypes: ($event.documentType === EDocumentTypeId.NIT || $event.documentType === EDocumentTypeId.SE) ? EPersonType.PERSON_TYPE_JUR : EPersonType.PERSON_TYPE_NAT
            };
        } else {
            this.solicitationData.contactsData = undefined;
            this.basicDataForm.patchValue({
                customer_exists: false,
                customer_loaded: true,
                customer_error: false
            });
            this.solicitationData.additionalData = {
                SolicitationType: '',
                SolicitationSubtype: '',
                Annotations: '',
                Cell: { id: '', name: '' },
                CustomerTypes: ($event.documentType === EDocumentTypeId.NIT || $event.documentType === EDocumentTypeId.SE) ? EPersonType.PERSON_TYPE_JUR : EPersonType.PERSON_TYPE_NAT
            };
        }

        this.solicitationData.basicData = this.basicDataForm.value;

        this.showContactForm = true;

    }

    /*
    /// ->  Getter Token service userData
    /// ->  Contexto servicio - Default
    /// ->  CONTENIDO AGREGADO LN 213...215
    /// ->  OM03560 - 24-12-22
    */
    getUserData = () => this._token?.userData?.names ?? '';

    /**
     * Permite obtener la instancia del formulario para la información de contactos del cliente
     */
    get contactsDataForm(): FormGroup {
        return this.form.get('contacts_data') as FormGroup;
    }

    public async nameLengthContacts() {
        let config = await this.cps.getCopy("form-solicitation-contacts-data");
        return getValueProperty(config, "nameLength", 20);
    }

}
